import { api_ } from '@shared/plugIn/axios';

import {
  GiftDeliveryZoneSearchParams,
  GiftDeliveryZoneSearchResult,
  GiftDeliveryZoneSummary,
} from './giftDeliveryZone.interface';

//* 시도 → 시군구별 읍면동 수와 추가배송비 범위 (안내 첫 화면)
export const getGiftDeliveryZoneSummary = async (
  giftItemBrand: string,
): Promise<GiftDeliveryZoneSummary> => {
  const { data } = await api_.get<GiftDeliveryZoneSummary>(
    `public/gift-delivery-zone/summary?giftItemBrand=${encodeURIComponent(
      giftItemBrand,
    )}`,
  );
  return data;
};

//* 읍면동/시군구 검색. 결과에 없는 읍면동 = 배송 불가. 한글은 URL 인코딩
export const searchGiftDeliveryZones = async (
  params: GiftDeliveryZoneSearchParams,
): Promise<GiftDeliveryZoneSearchResult> => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
    .join('&');
  const { data } = await api_.get<GiftDeliveryZoneSearchResult>(
    `public/gift-delivery-zone/search?${qs}`,
  );
  return data;
};
